import IconAIOffWhite from '@/components/icons/IconAIOffWhite'
import { useStoreAction } from '@/hooks/context/StoreActionContext';
import { Button, Typography } from '@mui/material'
import clsx from 'clsx';
import { useTranslations } from 'next-intl';
import React from 'react'

interface ButtonAiProps {
  isMobile?: boolean;
}

const ButtonAi = ({
  isMobile
}: ButtonAiProps) => {
  const t = useTranslations("messages");
  const { aiActionRef } = useStoreAction();
  return (
    <Button aria-label={"Open Chat"} onClick={() => aiActionRef?.current?.open()} className={clsx('!bg-gradient-to-r shadow-lg text-white from-[#1F61A9] to-[#A6CC17]  hover:shadow-xl transition-transform duration-200 tracking-wide hover:scale-[1.02] hover:!bg-[#3274bb] active:!scale-[0.98] !px-4 !py-2 gap-4 !rounded sm:!hidden xl:!flex justify-center items-center border-none !hidden')}>
      <IconAIOffWhite height={24} width={24} viewBox="0 0 32 32" sx={{
        width: "24px",
        height: "24px",
      }} />
      <Typography component="span" className='!font-semibold !text-[16px] !leading-[100%] !text-white' sx={{
        fontFamily: 'Inter',
      }}
        translation-key={"copilotkit_assistant_title"}
      >
        {t("copilotkit_assistant_title")}
      </Typography>
    </Button>
  )
}

export default ButtonAi